"use strict";

angular.module("imagetrend.components").directive("hlpFormBuilder", [
    "$uibModal",
    "FBResponses",
    "$sce",
    "Upload",
    "Resource",
    function ($uibModal, FBResponses, $sce, Upload, Resource) {
        return {
            restrict: "AE",
            scope: {
                form: "=?",
                resultSet: "=?",
                classes: "@?",
                formType: "=?",
                sets: "=?",
                elements: "=?",
                parameters: "=?",
                attachments: "=?",
                changesMade: "=?",
                showLayouts: "=?",
                showPages: "=?"
            },
            controller: [
                "$scope",
                "$rootScope",
                function($scope, $rootScope) {
                    $scope.scrlTabsApi = {};

                    if ($scope.form.pages && $scope.form.pages.length > 0) {
                        $scope.form.pages.forEach(function (page) {
                            if (page.tab_active) {
                                page.tab_active = false;
                            }
                        });
                        $scope.form.pages[0].tab_active = true;
                    }

                    if ($scope.showLayouts == null) {
                        $scope.showLayouts = true;
                    };

                    if ($scope.showPages == null) {
                        $scope.showPages = true;
                    };

                    $scope.label_position_options = [
                        { id: true, name: "Top" },
                        { id: false, name: "Left" }
                    ];

                    $scope.form.applicant_access =
                        $scope.form.applicant_access || 0;

                    $scope.form.apply_label_position = 0;
                    $scope.applyLabelPosition = function() {
                        // each question has a watcher on this variable, so all we need to do is change it, the value doesn't actually matter
                        $scope.form.apply_label_position++;
                    };

                    // Make the tab clicked the only active tab
                    $scope.switchActiveTab = function (pages, tab) {
                        // remove active classes
                        pages.forEach(function (page) {
                            if (page.id !== tab.id) {
                                page.tab_active = false;
                                var li = document.getElementById(page.id);
                                if (li) {
                                    li.classList.remove('active');
                                }
                            }
                        });

                        // add active class to the clicked tab
                        tab.tab_active = true;
                        if (tab.sections === undefined || tab.sections.length === 0) {
                            tab.sections = [{
                                name: "Section 1",
                                sort_order: 0,
                                components: [],
                            }];
                        }

                        setTimeout(function () {
                            tab.tab_active = true;
                            var li = document.getElementById(tab.id);
                            var liSection = document.getElementById("sections");
                            var liSectionPar = (liSection) ? liSection.parentElement : null;
                            if (li) {
                                li.classList.add('active');
                            }
                            if (liSectionPar) {
                                liSectionPar.classList.add('active');
                            }
                        }, 0);

                        // remove active from addPage (can happen with remove not select correct tab)
                        $scope.removeActiveAddPage();
                    }

                    // Remove Active Class from addPage Tab Button
                    $scope.removeActiveAddPage = function () {
                        setTimeout(function () {
                            var li = document.getElementById('addPage');
                            if (li) {
                                setTimeout(function () {
                                    li.classList.remove('active');
                                }, 0);
                            }
                        }, 0);
                    }

                    // Last page removed, add active class to addPage tab button
                    $scope.addActiveAddPage = function () {
                        setTimeout(function () {
                            $scope.form.pages.forEach(function (page) {
                                page.tab_active = false;
                                var li = document.getElementById(page.id);
                                if (li) {
                                    li.classList.remove('active');
                                }
                            });
                            var li = document.getElementById('addPage');
                            if (li) {
                                    li.classList.add('active');
                            }
                        }, 0);
                    }

                    $scope.addPage = function(form) {
                        if (form.pages == null) {
                            form.pages = [];
                        }

                        var newPage = {
                            id: guid(),
                            form_id: form.id,
                            hover: false,
                            sort_order: form.pages.length,
                            name: "Page " + (form.pages.length + 1),
                            sections: [
                                {
                                    name: "Section 1",
                                    sort_order: 0,
                                    components: [],
                                }
                            ],
                            tab_active: true,
                            show_save_button: false,
                            continue_button_label: "Save and Continue",
                            save_button_label: "Save",
                        };

                        // Make all tabs in-active
                        form.pages.forEach(function (page) {
                            page.tab_active = false;
                            var li = document.getElementById(page.id);
                            if (li) {
                                li.classList.remove('active'); // Remove the active class
                            }
                        });

                        // Add & make the tab active
                        form.pages.push(newPage);
                        setTimeout(function () {
                            newPage.tab_active = true;
                            var li = document.getElementById(newPage.id);
                            var liSection = document.getElementById("sections");
                            var liSectionPar = (liSection) ? liSection.parentElement : null;
                            if (li) {
                                li.classList.add('active');
                            }
                            if (liSectionPar) {
                                liSectionPar.classList.add('active');
                            }
                        }, 0);

                        $scope.switchActiveTab(form.pages, newPage);
                    };

                    $scope.removePage = function (pages, index) {
                        $uibModal
                            .open({
                                animation: true,
                                templateUrl: "templates/confirm/confirm.html",
                                controller: "ConfirmModalController",
                                resolve: {
                                    message: function() {
                                        return "Are you sure you want to delete this page?";
                                    }
                                }
                            })
                            .result.then(function (result) {
                                if (result) {
                                    pages.splice(index, 1);
                                    $scope.scrlTabsApi.doRecalculate();
                                    $scope.form.the_form.$setDirty();

                                    // Make next page active if possible
                                    const idx = pages.length > index ? index : null;
                                    if (idx !== null) {
                                        $scope.switchActiveTab(pages, pages[idx]);
                                    }
                                    else {
                                        // Try the previous page
                                        const pdx = pages.length > index - 1 ? index - 1 : null;
                                        if (pdx !== null && pdx > -1) {
                                            $scope.switchActiveTab(pages, pages[pdx]);
                                        }
                                        else {
                                            $scope.addActiveAddPage()
                                        }
                                    }

                                }
                            });
                    };

                    $scope.pageNameChanged = function() {
                        $scope.form.the_form.$setDirty();
                    };

                    $scope.openPageSettings = function(pages, index) {
                        var page = pages[index];

                        $uibModal
                            .open({
                                animation: true,
                                templateUrl:
                                    "templates/page-settings/page-settings.html",
                                controller: "PageSettingsModalController",
                                resolve: {
                                    continue_button_label: function() {
                                        return page.continue_button_label;
                                    },
                                    show_save_button: function() {
                                        return page.show_save_button;
                                    },
                                    save_button_label: function() {
                                        return page.save_button_label;
                                    },
                                    page_name: function () {
                                        return page.name;
                                    },
                                }
                            })
                            .result.then(function(result) {
                                if (result != null) {
                                    pages[index].continue_button_label =
                                        result.continue_button_label;
                                    pages[index].show_save_button =
                                        result.show_save_button;
                                    pages[index].save_button_label =
                                        result.save_button_label;
                                    pages[index].name =
                                        result.page_name;
                                    if (result.changed) {
                                        $scope.form.the_form.$setDirty();
                                    }
                                }
                            });
                    };

                    $scope.switchView = function (layout) {
                        $scope.builderType = layout;
                    };

                    $scope.savePageSettings = function(page) {
                        page.show_settings = false;
                    };

                    $scope.addSection = function(page) {
                        if (page.sections == null) {
                            page.sections = [];
                        }

                        page.sections.push({
                            id: guid(),
                            page_id: page.id,
                            sort_order: page.sections.length,
                            name: "Section " + (page.sections.length + 1),
                            components: []
                        });

                        $scope.form.the_form.$setDirty();
                    };

                    $scope.removeSection = function(sections, index) {
                        $uibModal
                            .open({
                                animation: true,
                                templateUrl: "templates/confirm/confirm.html",
                                controller: "ConfirmModalController",
                                resolve: {
                                    message: function() {
                                        return "Are you sure you want to delete this section?";
                                    }
                                }
                            })
                            .result.then(function(result) {
                                if (result) {
                                    sections.splice(index, 1);
                                    $scope.form.the_form.$setDirty();
                                }
                            });
                    };

                    $scope.initComponent = function(component) {
                        if (component.initialQuestions == null) {
                            component.initialQuestions = [];
                        }
                        component.initialQuestions[
                            component.component_type_id
                        ] = component.questions;
                        component.parameters = angular.copy($scope.parameters);
                        //limit document type ids
                        component.parameters.limit_document_type_ids =
                            component.limit_document_type_ids;
                        component.limit_document_type_ids_array = component.limit_document_type_ids_array =
                            component.limit_document_type_ids == null
                                ? []
                                : component.limit_document_type_ids;
                        //limit position ids
                        component.parameters.limit_position_ids =
                            component.limit_position_ids;
                        component.limit_position_ids_array = component.limit_position_ids_array =
                            component.limit_position_ids == null
                                ? []
                                : component.limit_position_ids;
                        // limit certification levels
                        component.parameters.limit_license_level_ids =
                            component.limit_license_level_ids;
                        component.limit_license_level_ids_array = component.limit_license_level_ids_array =
                            component.limit_license_level_ids == null
                                ? []
                                : component.limit_license_level_ids;
                        //limit vehicle type ids
                        component.parameters.limit_vehicle_type_ids =
                            component.limit_vehicle_type_ids;
                        component.limit_vehicle_type_ids_array = component.limit_vehicle_type_ids_array =
                            component.limit_vehicle_type_ids == null
                                ? []
                            : component.limit_vehicle_type_ids;
                        //skills
                        component.parameters.skill_question_ids =
                            component.skill_question_ids;
                        component.parameters.skill_show_points =
                            component.skill_show_points;
                        component.parameters.skill_default =
                            component.skill_default;
                        component.updateEditList = false;
                        component.updateSelectedList = false;

                        if ($scope.sets != null) {
                            $scope.sets.forEach(function(set) {
                                if (set.id == component.data_set_id) {
                                    component.data_set = angular.copy(set);
                                    if (component.license_category_id == null) {
                                        component.license_category_id =
                                            set.default_license_category_id;
                                    } else {
                                        if (
                                            component.parameters
                                                .orignalLicenseID == null &&
                                            component.parameters.license_id !=
                                                null
                                        ) {
                                            component.parameters.orignalLicenseID =
                                                component.parameters.license_id;
                                        }

                                        component.parameters.license_category_id =
                                            component.license_category_id;

                                        if (
                                            component.data_set
                                                .default_license_category_id ==
                                            component.license_category_id
                                        ) {
                                            component.parameters.license_id =
                                                component.parameters.orignalLicenseID;
                                        } else {
                                            component.parameters.license_id = null;
                                            if (
                                                component.data_set.code ==
                                                "certification"
                                            ) {
                                                component.data_set.data_points
                                                    .slice()
                                                    .reverse()
                                                    .forEach(function(
                                                        point,
                                                        index,
                                                        object
                                                    ) {
                                                        if (
                                                            point.code ==
                                                            "certification_application_type"
                                                        ) {
                                                            component.data_set.data_points.splice(
                                                                object.length -
                                                                    1 -
                                                                    index,
                                                                1
                                                            );
                                                        }
                                                    });
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    };

                    $scope.addComponent = function(section) {
                        if (section.components == null) {
                            section.components = [];
                        }

                        section.components.push({
                            id: guid(),
                            section_id: section.id,
                            sort_order: section.components.length,
                            questions: [],
                            edit: true,
                            component_conditions: [],
                            allow_multiple_groups: false,
                            maximum_groups: null,
                            groups_until_list: 2,
                            limit_document_type_ids: null,
                            limit_position_ids: null,
                            limit_license_level_ids: null,
                            limit_vehicle_type_ids: null,
                            skill_question_ids: null,
                            skill_show_points: true,
                            skill_default: 0,
                            content_type: 0,
                            update_from_form_add: true
                        });

                        $scope.form.the_form.$setDirty();
                    };

                    $scope.removeComponent = function(components, index) {
                        $uibModal
                            .open({
                                animation: true,
                                templateUrl: "templates/confirm/confirm.html",
                                controller: "ConfirmModalController",
                                resolve: {
                                    message: function() {
                                        return "Are you sure you want to delete this component?";
                                    }
                                }
                            })
                            .result.then(function(result) {
                                if (result) {
                                    components.splice(index, 1);
                                    $scope.form.the_form.$setDirty();
                                }
                            });
                    };

                    $scope.pageOptions = {
                        containment: "#pages",
                        scrollableContainer: "#pages",
                        containerPositioning: "relative",
                        accept: function(
                            sourceItemHandleScope,
                            destSortableScope
                        ) {
                            return (
                                sourceItemHandleScope.itemScope.sortableScope
                                    .$id === destSortableScope.$id
                            );
                        },
                        orderChanged: function(event) {
                            $scope.form.the_form.$setDirty();
                        }
                    };

                    $scope.sectionOptions = {
                        containment: "#sections",
                        scrollableContainer: "#sections",
                        containerPositioning: "relative",
                        accept: function(
                            sourceItemHandleScope,
                            destSortableScope
                        ) {
                            return (
                                sourceItemHandleScope.itemScope.sortableScope
                                    .$id === destSortableScope.$id
                            );
                        },
                        orderChanged: function(event) {
                            $scope.form.the_form.$setDirty();
                        },
                        itemMoved: function(event) {
                            $scope.form.the_form.$setDirty();
                        }
                    };

                    $scope.componentOptions = {
                        containment: "#sections",
                        scrollableContainer: "#sections",
                        containerPositioning: "relative",
                        accept: function(
                            sourceItemHandleScope,
                            destSortableScope
                        ) {
                            return (
                                sourceItemHandleScope.itemScope.sortableScope
                                    .$parent.$parent.$id ===
                                    destSortableScope.$parent.$parent.$id ||
                                sourceItemHandleScope.itemScope.sortableScope
                                    .$parent.$parent.$parent.$parent.$id ===
                                    destSortableScope.$parent.$parent.$id
                            );
                        },
                        orderChanged: function(event) {
                            $scope.form.the_form.$setDirty();
                        },
                        itemMoved: function(event) {
                            $scope.form.the_form.$setDirty();
                        }
                    };

                    // Functions for editing and cancelling out of components
                    $scope.editElement = function(element) {
                        element.edit = true;
                        element.original = angular.copy(element);
                    };
                    $scope.revertElement = function(element) {
                        angular.copy(element.original, element);
                        element.edit = false;
                    };

                    $scope.form.allDisabled = false;
                    $scope.toggleAllDisabled = function() {
                        // There's a listener on each question to update this
                        $scope.form.allDisabled = !$scope.form.allDisabled;
                        $scope.form.the_form.$setDirty();
                    };

                    $scope.form.allUpdateFromForm = false;
                    $scope.toggleAllUpdate = function() {
                        // There's a listener on each question to update this
                        $scope.form.allUpdateFromForm = !$scope.form
                            .allUpdateFromForm;
                        $scope.form.the_form.$setDirty();
                    };

                    $scope.form.allShowInGrid = false;
                    $scope.toggleAllShowInGrid = function() {
                        // There's a listener on each question to update this
                        $scope.form.allShowInGrid = !$scope.form.allShowInGrid;
                        $scope.form.the_form.$setDirty();
                    };

                    $scope.form.allRequired = false;
                    $scope.toggleAllRequired = function() {
                        // There's a listener on each question to update this
                        $scope.form.allRequired = !$scope.form.allRequired;
                        $scope.form.the_form.$setDirty();
                    };

                    //default the label position to be "left"
                    if (!$scope.form.label_position) {
                        $scope.form.label_position = false;
                    }

                    //default the show_changed_answers to be false
                    if (!$scope.form.display_changed_answers) {
                        $scope.form.display_changed_answers = false;
                    }

                    $scope.checkIfImageOrPDF = function (component) {
                        if (component.document_file_name) {
                            var extensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf'];
                            return extensions.includes(component.document_file_name.split('.').pop().toLowerCase());
                        }
                        return false;
                    }

                    $scope.getDocumentURL = function (component) {
                        return (
                            $rootScope.internalURL +
                            "controller.cfm?method=publicPortalService.openDocument" +
                            "&documentID=" +
                            component.document_id.toUpperCase() +
                            "&code=" +
                            component.document_code
                        );
                    };
                }
            ],
            replace: true,
            transclude: true,
            templateUrl: "templates/form-builder/form-builder.html",
            link: function(scope, elem, attrs, ctrl) {
                scope.builderType = true;

                scope.pdf_preview_content = null;
                scope.processing_pdf = false;

                scope.getPDFPreviewContent = function () {
                    if (scope.pdf_preview_content == null && scope.processing_pdf == false) {
                        scope.processing_pdf = true;
                        FBResponses.getPDFFileContent(
                            scope.form,
                            scope.parameters,
                            true
                        ).then(function (pdf) {
                            scope.processing_pdf = false;
                            if (pdf != null && pdf.file_content != null) {
                                // handle IE
                                var browser = Resource.browser();
                                if (
                                    browser.indexOf("Edge") >= 0 ||
                                    browser.indexOf("IE") >= 0
                                ) {
                                    navigator.msSaveOrOpenBlob(
                                        Upload.dataUrltoBlob(pdf.file_content)
                                    );
                                    var doc = elem[0].querySelector(
                                        "[id='component_pdf_preview']"
                                    ).contentWindow.document;
                                    doc.open();
                                    doc.write("Open PDF to preview.");
                                    doc.close();
                                } else {
                                    scope.pdf_preview_content = $sce.trustAsResourceUrl(
                                        URL.createObjectURL(
                                            Upload.dataUrltoBlob(
                                                pdf.file_content
                                            )
                                        )
                                    );
                                }
                            }
                        });
                    }
                };
            }
        };
    }
]);
